var map = {
	"./zoom_in_dark.svg": "4326",
	"./zoom_in_disabled.svg": "b1cc",
	"./zoom_in_light.svg": "dc6a",
	"./zoom_out_dark.svg": "5538",
	"./zoom_out_disabled.svg": "ddd4",
	"./zoom_out_light.svg": "3e42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1edd";